import React, { useState } from 'react'

import useAxios, { mutate, cache } from 'hooks/useAxios'
import { toast } from 'libs/toast'
import { SurveyDeliveryMethodInput } from '.'
import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setSurveyFromId } from 'actions'

export function SurveyDeliveryMethodInputContainer() {
  const { surveyId } = useParams()
  const { fetch: updateSurvey } = useAxios({
    url: `account/survey/${surveyId}/`,
    method: 'patch',
    skip: true,
  })
  const dispatch = useDispatch()
  const [isSaving, setIsSaving] = useState(false)

  function handleChange(embedIntegration) {
    if (isSaving) {
      return
    }
    setIsSaving(true)
    const { name: deliveryType, connectorId } = embedIntegration
    updateSurvey({
      data: {
        type: deliveryType,
        connector: connectorId,
      },
    })
      .then(async () => {
        const surveyCacheKey = `account/survey/${surveyId}/`
        const cachedSurvey = cache.get(surveyCacheKey)
        if (cachedSurvey && cachedSurvey.token) {
          await mutate(`survey/email-delivery-setting/${cachedSurvey.token}/`)
        }
        const updatedSurvey = {
          ...(cachedSurvey || {}),
          id: surveyId,
          type: deliveryType,
          connector: connectorId,
        }
        mutate(surveyCacheKey, updatedSurvey, false)
        dispatch(setSurveyFromId(updatedSurvey))
      })
      .catch((e) => {
        console.error(e)
        setIsSaving(false)
        toast.error('Oops, there was an error updating the delivery method. Please try again.')
      })
  }

  return (
    <SurveyDeliveryMethodInput onChange={handleChange} loading={isSaving} enableOneoffEmailSurvey />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyDeliveryMethodInput/container.js